import React, { useMemo } from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";

export const ManufacturingPlight = (props) => {
  const { t } = useTranslation();
  const text = useMemo(() => {
    return {
      title: t("manufacturing.plight.title"),
      desc: t("manufacturing.plight.desc"),
      itemOne: {
        title: t("manufacturing.plight.itemOne.title"),
        desc: t("manufacturing.plight.itemOne.desc"),
        role: t("manufacturing.plight.itemOne.role"),
      },
      itemTwo: {
        title: t("manufacturing.plight.itemTwo.title"),
        desc: t("manufacturing.plight.itemTwo.desc"),
        role: t("manufacturing.plight.itemTwo.role"),
      },
    };
  }, [t]);
  return (
    <div style={{ background: "#f7f8fa" }}>
      <section className="manufacturing-plight basic-column">
        <h1 className="manufacturing-title basic-title">{text.title}</h1>
        <div className="manufacturing-title-desc">{text.desc}</div>
        <ul className="manufacturing-plight-tabs basic-column">
          <li className="item">
            <div className="itemTitle">{text.itemOne.title}</div>
            <div className="itemDesc">{text.itemOne.desc}</div>
            <div className="itemRole">{text.itemOne.role}</div>
          </li>
          <li className="item">
            <div className="itemTitle">{text.itemTwo.title}</div>
            <div className="itemDesc">{text.itemTwo.desc}</div>
            <div className="itemRole">{text.itemTwo.role}</div>
          </li>
        </ul>
      </section>
    </div>
  );
};
